<div class="row">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator" ></ngx-loading>
        <div class="row">              
            <div class="col-md-9">
                <div widget class="card border-0 box-shadow">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0">Message Type</h5>
                        <p class="fs-13 text-gray">Please select message type.</p>        
                    </div>
                    <div class="card-body pt-0 widget-body">
                        <div class="row">
                            <div class="col-md-4">
                                <button type="button" (click)="setMessageType(MESSAGE_TYPE.PUSH)"
                                    class="btn btn-md btn-block btn-secondary "
                                    [class.btn-secondary]="getMessageType() !== MESSAGE_TYPE.PUSH" 
                                    [class.btn-gray]="getMessageType() === MESSAGE_TYPE.PUSH">
                                    Mobile Notifications
                                </button> &nbsp;&nbsp;
                            </div>
                            <div class="col-md-4">
                                <button type="button" (click)="setMessageType(MESSAGE_TYPE.SMS)"
                                    class="btn btn-md btn-block btn-secondary"
                                    [class.btn-secondary]="getMessageType() !== MESSAGE_TYPE.SMS"  
                                    [class.btn-gray]="getMessageType() === MESSAGE_TYPE.SMS">
                                    SMS Message
                                </button>&nbsp;&nbsp;
                            </div>
                            <div class="col-md-4">
                                <button type="button" (click)="setMessageType(MESSAGE_TYPE.EMAIL);mailSent=false;"
                                    class="btn btn-md btn-block btn-secondary"
                                    [class.btn-secondary]="getMessageType() !== MESSAGE_TYPE.EMAIL"  
                                    [class.btn-gray]="getMessageType() === MESSAGE_TYPE.EMAIL">
                                    Email
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <br />

        <!-- PUSH NOTIFICATION WINDOW -->
        <div class="row" *ngIf="getMessageType() == MESSAGE_TYPE.PUSH">
            <div class="col-md-6">
                <div widget class="card border-0 box-shadow">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0">Mobile Notications</h5>
                        <p class="fs-13 text-gray">Please enter message.</p>                       
                    </div>
                    <div class="card-body pt-0 widget-body">
                        <div class="form-group">
                            <label for="subject" placeholder="Select Recipient here">Select Recipient: </label>&nbsp;
                            <ss-multiselect-dropdown [options]="pushRecipientOptions" [(ngModel)]="pushRecipientModel" [texts]="pushRecipientTexts" [settings]="pushRecipientSettings"></ss-multiselect-dropdown>                        
                            &nbsp;<small *ngIf="!checkPushModel()" class="text-danger" >Required</small>
                        </div>
                        <div class="form-group">
                                <label for="subject" placeholder="Enter Subject here">Subject:</label>
                                <input type="text" class="form-control form-control-sm" id="subject" [(ngModel)]="pushSubject">
                                <small *ngIf="!pushSubject" class="text-danger" >Required.</small>
                            </div>
                        <div class="form-group">
                            <label for="textarea-1" placeholder="Enter Message here.">Message</label>
                            <textarea class="form-control form-control-sm" id="textarea-1" [(ngModel)]="pushMessage" rows="4"></textarea>
                            <small *ngIf="!checkPushMessage()" class="text-danger" >Required</small>
                        </div>
                    </div>
                    <div class="card-footer text-center">
                        <button type="button" class="pull-right btn btn-sm btn-secondary" (click)="cancel()">Cancel</button>
                        <button type="submit" class="pull-right btn btn-sm btn-success mr-2" (click)="sendPush()" [disabled]="!checkPushModel() || !pushSubject || !checkPushMessage() || spinner == true">Send</button>&nbsp;
                        <i class="fa fa-spinner fa-spin pull-right mr-2" *ngIf="spinner == true"></i>
                    </div>
                </div>
            </div>
        </div>

        <!---- SMS NOTIFICATION WINDOW -->

        <div class="row" *ngIf="getMessageType() == MESSAGE_TYPE.SMS">
            <div class="col-md-6">
                <div widget class="card border-0 box-shadow">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0">SMS Message</h5>
                        <p class="fs-13 text-gray">Please enter message.</p>                        
                    </div>
                    <div class="card-body pt-0 widget-body">
                        <div class="form-group">
                            <label for="subject" placeholder="Select Recipient">Select Recipient: </label>&nbsp;
                            <ss-multiselect-dropdown [options]="smsRecipientOptions" [(ngModel)]="smsRecipientModel" [texts]="smsRecipientTexts" [settings]="smsRecipientSettings"></ss-multiselect-dropdown>                        
                            &nbsp;<small *ngIf="!checkSMSModel()" class="text-danger" >Required</small>
                        </div>
                    
                        <div class="form-group">
                            <label for="textarea-1" placeholder="Enter Message here.">Message</label>
                            <textarea class="form-control form-control-sm" id="textarea-1" [(ngModel)]="smsMessage" rows="4"></textarea>
                            <small *ngIf="!checkSMSMessage()" class="text-danger" >Required</small>
                        </div>
                    </div>
                    <div class="card-footer text-center">
                        <button type="button" class="pull-right btn btn-sm btn-secondary" (click)="cancel()">Cancel</button>
                        <button type="submit" class="pull-right btn btn-sm btn-success mr-2" (click)="sendSMS()" [disabled]="!checkSMSModel() || !checkSMSMessage() || spinner == true">Send</button>
                        <i class="fa fa-spinner fa-spin pull-right mr-2" *ngIf="spinner == true"></i>
                    </div>
                </div>
            </div>
        </div>

        <!---- EMAIL MESSAGE WINDOW -->

        <div class="row" *ngIf="getMessageType() == MESSAGE_TYPE.EMAIL">
            <div class="col-md-9">
                <div widget class="card border-0 box-shadow">
                    <div class="card-header transparent border-0 text-muted">
                        <h5 class="mb-0">Send Email Message</h5>
                        <p class="fs-13 text-gray">Please enter message.</p>                        
                    </div>
                    <div class="card-body pt-0 widget-body">
                        <div class="container">
                            <form [formGroup]="mailForm" (ngSubmit)="onSubmitEmail()">
                                <div class="form-group">
                                    <small class="text-danger" *ngIf="mailForm.controls.recipient.errors?.pattern">Emails must be a valid email addresses separated by a comma.</small>
                                    <input class="form-control form-control-sm" placeholder="Recipient" formControlName="recipient" required><br />
                                   <input class="form-control form-control-sm" placeholder="Subject" formControlName="subject" required><br />
                                    <angular-editor formControlName="body" [config]="editorConfig" required></angular-editor>
                                </div>
                                
                                <div class="form-group">
                                    <button type="submit" class="btn btn-sm btn-block btn-md"  
                                    [ngClass]="{'btn-success': mailSent == false, 'btn-gray': mailSent == true}"
                                    [disabled]="!mailForm.valid || mailSent == true || spinner == true"><i class="fa fa-spinner fa-spin mr-1" *ngIf="spinner == true"></i>Send</button>
                                </div>
                            </form>
                        </div>                
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- START OF LIST TABLE -->
    
<!-- END OF MODAL FORM -->
    